/*
 * Parsec
 * https://github.com/d-plaindoux/parsec
 *
 * Copyright (c) 2016 Didier Plaindoux
 * Licensed under the LGPL2 license.
 */

import parser from './parser';
import response from './response';
import flow from './flow-bundle';
import chars from './chars-bundle';
import numbers from './numbers-bundle';

export const C = chars;
export const F = flow;
export const N = numbers;

export default {parser, response};
